import React, { FC } from 'react'

import ProductCarousel from './ProductCarousel'
import useProductFeedCarouselData from '../hooks/useProductFeedCarouselData'
import { Product } from '../../utils/types/Product'

import styles from '../../styles/LandingPage/ProductCategoryCarousel.module.less'

interface ProductCategoryCarouselProps {
  productFeed: Product[]
  sliceRange: [number, number]
}

const ProductCategoryCarousel: FC<ProductCategoryCarouselProps> = (props) => {
  const { productFeed, sliceRange = [0, 15] } = props

  const { products, isLoading, title, carouselType } = useProductFeedCarouselData({
    productFeed,
    sliceRange,
  })

  const isValidProducts = products && products.length > 0
    && products.every((product) => product.media)

  if (!isValidProducts && !isLoading) {
    return null
  }

  return (
    <section className={styles['product-category-carousel-wrapper']}>
      <div className={styles['product-category-carousel']}>
        <h3 className={styles['product-category-carousel-title']}>
          {title}
        </h3>
        <ProductCarousel
          carouselType={carouselType}
          productCardType="narrow"
          className={styles['product-category-carousel-content']}
          products={products}
          isLoading={isLoading}
          carouselGap={20}
        />
      </div>
    </section>
  )
}

export default ProductCategoryCarousel
